import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
import { messagingPermissionKeys } from '@app/hcs-shared/permissions/messaging';
export const PermissionKeyFE_MessagingUI_Release = new PermissionKey_FE(messagingPermissionKeys.Release);
export const PermissionKeyFE_MessagingUI_Beta = new PermissionKey_FE(messagingPermissionKeys.Beta);
//# sourceMappingURL=messaging.js.map